import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import {NanobarService} from "./nanobar.service";

/**
 * Opt a request out of the nanobar (e.g. background polling):
 *   this.http.get(url, { context: new HttpContext().set(SKIP_NANOBAR, true) })
 */
export const SKIP_NANOBAR = new HttpContextToken<boolean>(() => false);

export const nanobarInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_NANOBAR)) {
    return next(req);
  }

  const nanobar = inject(NanobarService);
  nanobar.start();

  // finalize runs on success, error, AND cancellation (unsubscribe / switchMap)
  return next(req).pipe(finalize(() => nanobar.complete()));
};
